import axios from "axios";
import { createHashPassword } from "../helpers/createHashPassword";

export interface TribalAdmin {
  userName?: string;
  oneTimePassword?: string;
  passwordHash?: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phone: string;
  createVia: string;
  biaNumber?: string;
  organizationCodeNumber?: string;
  address1: string;
  city: string;
  stateCode: string;
  zip: string;
  organizationID: number;
}

export const createTribalAdmin = async (tribalAdmin: TribalAdmin) => {
  if (tribalAdmin.oneTimePassword) {
    const hashPassword = await createHashPassword(tribalAdmin.oneTimePassword);
    tribalAdmin.passwordHash = hashPassword;
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/User/create-tribal-admin`,
      tribalAdmin
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
